function supportWebp(): boolean {
  const ele = document.createElement('canvas')
  ele.width = 1
  ele.height = 1
  return (
    ele.toDataURL &&
    ele.toDataURL('image/webp').indexOf('data:image/webp') === 0
  )
}

function optimizeImage(
  value: string,
  width: number | undefined,
  height: number | undefined,
  viewType = '2'
) {
  const suffix = supportWebp() ? 'webp' : 'jpg'
  let imgUrl = `${value}?imageView2/${viewType}`
  imgUrl = imgUrl.replace(/^http(s?):/, '')
  if (width) {
    imgUrl += `/w/${width}`
  }
  if (height) {
    imgUrl += `/h/${height}`
  }
  imgUrl += `/q/80/format/${suffix}`
  return imgUrl
}

export function compressImage(
  value: string,
  width: number | undefined,
  height: number | undefined,
  isTailor = false
) {
  let img = ''
  const isSupportWebp = supportWebp()
  if (value) {
    value = value.replace(/^http(s?):/, '')
    if (isSupportWebp && isTailor) {
      img = `${value}?imageMogr2/crop/${width}x${height}/q/80/format/webp`
    } else if (isSupportWebp && !isTailor) {
      img = optimizeImage(value, width, height)
    } else if (!isSupportWebp && isTailor) {
      img = `${value}?imageMogr2/crop/${width}x${height}/q/80/format/jpg`
    } else {
      img = optimizeImage(value, width, height)
    }
  }
  return img
}
